import moment from "moment";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReminderPopup = ({
  isOpen,
  onClose,
  onSubmit,
  dropdownOptions,
  data,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  // Sync initial UTC data into local Date object
  useEffect(() => {
    if (data) {
      const localDate = moment.utc(data).local().toDate();
      setSelectedDate(localDate);
    }
  }, [data]);

  const handleChange = (date) => {
    setSelectedDate(date);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedDate = moment(selectedDate).format("YYYY-MM-DD HH:mm:ss");
    onSubmit({ reminder: formattedDate });
    setSelectedDate(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-11">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Subscriber :
              </h5>
            </div>
            <button type="button" className="btn btn-default" onClick={onClose}>
              &times;
            </button>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <DatePicker
                      selected={selectedDate}
                      onChange={handleChange}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={1}
                      dateFormat="yyyy-MM-dd HH:mm:ss"
                      placeholderText="Select date and time"
                    />
                  </div>
                </div>

                <div className="col-md-12" style={{ textAlign: "right" }}>
                  <button type="submit" className="btn btn-primary mx-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderPopup;
